import { GridValidRowModel } from '@mui/x-data-grid-premium'
import { GridCellParams, GridColDef } from '@mui/x-data-grid-pro'
import React from 'react'
import DataGridCellWrapper from 'src/components/DataGrid/cells/DataGridCellWrapper/DataGridCellWrapper'
import SvgChevronRight from 'src/components/Svgs/SvgChevronRight'

const ChevronCell = <Row extends GridValidRowModel>(props: {
  params: GridCellParams<Row>
}) => {
  return (
    <DataGridCellWrapper params={props.params}>
      <SvgChevronRight />
    </DataGridCellWrapper>
  )
}

export default ChevronCell

export const chevronColumnDef: GridColDef = {
  field: 'chevron',
  headerName: 'Chevron',
  disableColumnMenu: true,
  resizable: false,
  sortable: false,
  hideable: false,
  headerClassName: 'hideRightSeparator',
  width: 56, // 16 + 24 + 16 (padding)
  renderCell: (params) => <ChevronCell params={params} />,
  renderHeader: () => <></>,
}
